module.exports = __webpack_public_path__ + "static/RiskFree-9e20a6c84b5b2019b670c807942a92b3.png";